import React from 'react';

const CodeIcon = () => {
    return (
        <svg
            width="24"
            height="36"
            viewBox="0 0 24 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.00344 19C8.34344 19.33 7.79344 19.82 7.38344 20.43C7.15344 20.78 7.15344 21.22 7.38344 21.57C7.79344 22.18 8.34344 22.67 9.00344 23"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.2109 19C15.8709 19.33 16.4209 19.82 16.8309 20.43C17.0609 20.78 17.0609 21.22 16.8309 21.57C16.4209 22.18 15.8709 22.67 15.2109 23"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 28H15C20 28 22 26 22 21V15C22 10 20 8 15 8H9C4 8 2 10 2 15V21C2 26 4 28 9 28Z"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.22656 14.01L21.4466 14"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CodeIcon;
